export var PaymentFormProps;
(function (PaymentFormProps) {
    PaymentFormProps["addressLine1"] = "addressLine1";
    PaymentFormProps["addressLine2"] = "addressLine2";
    PaymentFormProps["city"] = "city";
    PaymentFormProps["houseNumber"] = "houseNumber";
    PaymentFormProps["charityEmailOptIn"] = "charityEmailOptIn";
    PaymentFormProps["isAddressFromLookup"] = "isAddressFromLookup";
    PaymentFormProps["country"] = "country";
    PaymentFormProps["email"] = "email";
    PaymentFormProps["firstName"] = "firstName";
    PaymentFormProps["giftAid"] = "giftAid";
    PaymentFormProps["taxReceipt"] = "taxReceipt";
    PaymentFormProps["lastName"] = "lastName";
    PaymentFormProps["autoEnroll"] = "autoEnroll";
    PaymentFormProps["emailOptIn"] = "emailOptIn";
    PaymentFormProps["annualReminderOptIn"] = "annualReminderOptIn";
    PaymentFormProps["postalCode"] = "postalCode";
    PaymentFormProps["tipPercent"] = "tipPercent";
    PaymentFormProps["tipValue"] = "tipValue";
    PaymentFormProps["campaign"] = "campaign";
    PaymentFormProps["partner"] = "partner";
    PaymentFormProps["phone"] = "phone";
    PaymentFormProps["state"] = "state";
    PaymentFormProps["countryCode"] = "countryCode";
})(PaymentFormProps || (PaymentFormProps = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGF5bWVudEZvcm1EYXRhLmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbImRhdGEvcGF5bWVudEZvcm1EYXRhLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWdDQSxNQUFNLENBQU4sSUFBWSxnQkF3Qlg7QUF4QkQsV0FBWSxnQkFBZ0I7SUFDMUIsaURBQTZCLENBQUE7SUFDN0IsaURBQTZCLENBQUE7SUFDN0IsaUNBQWEsQ0FBQTtJQUNiLCtDQUEyQixDQUFBO0lBQzNCLDJEQUF1QyxDQUFBO0lBQ3ZDLCtEQUEyQyxDQUFBO0lBQzNDLHVDQUFtQixDQUFBO0lBQ25CLG1DQUFlLENBQUE7SUFDZiwyQ0FBdUIsQ0FBQTtJQUN2Qix1Q0FBbUIsQ0FBQTtJQUNuQiw2Q0FBeUIsQ0FBQTtJQUN6Qix5Q0FBcUIsQ0FBQTtJQUNyQiw2Q0FBeUIsQ0FBQTtJQUN6Qiw2Q0FBeUIsQ0FBQTtJQUN6QiwrREFBMkMsQ0FBQTtJQUMzQyw2Q0FBeUIsQ0FBQTtJQUN6Qiw2Q0FBeUIsQ0FBQTtJQUN6Qix5Q0FBcUIsQ0FBQTtJQUNyQix5Q0FBcUIsQ0FBQTtJQUNyQix1Q0FBbUIsQ0FBQTtJQUNuQixtQ0FBZSxDQUFBO0lBQ2YsbUNBQWUsQ0FBQTtJQUNmLCtDQUEyQixDQUFBO0FBQzdCLENBQUMsRUF4QlcsZ0JBQWdCLEtBQWhCLGdCQUFnQixRQXdCM0IifQ==